import { useQuery } from 'react-query';
import QUERY_CACHE_KEY from '@constants/QueryCacheKey';

function useNotificationsSettingsQuery(options) {
  return useQuery(QUERY_CACHE_KEY.notificationsSettings(), options);
}

export default useNotificationsSettingsQuery;
